import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
} from '../../../../../store/modules/ProjetoActions';

import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import { openModal } from '../../../../../store/modules/ModalActions';
import { etapaIsUnlocked } from '../../../../../utils/ProjetoUtils';

class Etapa2_1Card1 extends GenericProjectCard {
  stepIndex = 2;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoPerguntaExploratoriaChanged: false,
      descricaoTerritorioInvestigadoChanged: false,
    };

    this.setValue = this.setValue.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  descricaoPerguntaExploratoriaIsValid() {
    return this.props.projeto.descricaoPerguntaExploratoria
      ? this.props.projeto.descricaoPerguntaExploratoria.length > 0
      : false;
  }

  descricaoTerritorioInvestigadoIsValid() {
    return this.props.projeto.descricaoTerritorioInvestigado
      ? this.props.projeto.descricaoTerritorioInvestigado.length > 0
      : false;
  }

  render() {
    this.validationResults = !etapaIsUnlocked(
      this.stepIndex,
      this.props.projeto.avaliacoes
    )
      ? [true]
      : [
          this.descricaoPerguntaExploratoriaIsValid(),
          this.descricaoTerritorioInvestigadoIsValid(),
        ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa2_1}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa2_1,
        }}
      >
        <form
          className={this.getFormClasses()}
          onSubmit={(event) => {
            event.preventDefault();
            if (this.itemsAreValid(this.validationResults)) {
              this.toNext();
            }
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoPerguntaExploratoria}
                name='descricaoPerguntaExploratoria'
                value={this.props.projeto.descricaoPerguntaExploratoria ?? ''}
                onChange={this.setValue}
                error={!this.descricaoPerguntaExploratoriaIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoTerritorioInvestigado}
                name='descricaoTerritorioInvestigado'
                value={this.props.projeto.descricaoTerritorioInvestigado || ''}
                onChange={this.setValue}
                error={!this.descricaoTerritorioInvestigadoIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa2_1,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              null,
              this.getNextButton(
                !etapaIsUnlocked(
                  this.stepIndex,
                  this.props.projeto.avaliacoes
                ) || this.itemsAreValid(this.validationResults)
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa2_1Card1));
